export type Bonus = {
  number: number;
  title: string;
  headline: string;
  intro: string;
  items: string[];
  note?: string;
  value: number;
  image: string;
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: "The 100 Alopecia Clinical Cases Library™",
    headline: "Study 100 Hair Loss Scenarios Through Structured Educational Case Review.",
    intro: "Instead of reviewing isolated clinical facts, explore organized case scenarios.",
    items: [
      "100 educational case scenarios.",
      "Hair loss presentation summaries.",
      "Clinical observation worksheets.",
      "Relevant trichoscopy findings.",
      "Differential diagnosis discussion questions.",
      "Structured case review exercises.",
    ],
    note: "Cases are hypothetical or use appropriately authorized and de-identified clinical material.",
    value: 19,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/4018f3f2-5072-4534-8d97-4dbb9a3683db.jpg",
  },
  {
    number: 2,
    title: "The Trichoscopy Visual Master Atlas™",
    headline: "Review Important Hair and Scalp Findings Through Visual Comparisons.",
    intro:
      "This resource complements the trichoscopy volume with additional organized visual references.",
    items: [
      "Hair shaft comparison illustrations.",
      "Follicular opening references.",
      "Yellow dot and black dot examples.",
      "Perifollicular finding comparisons.",
      "Scalp pattern study sheets.",
      "Visual interpretation worksheets.",
    ],
    value: 17,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/f48755a5-4183-4c08-8f1c-88ed70a87051.jpg",
  },
  {
    number: 3,
    title: "The Alopecia Differential Diagnosis Flowcharts™",
    headline: "Organize Complex Hair Loss Presentations Into Clear Educational Decision Maps.",
    intro: "Explore structured flowcharts for reviewing different presentations.",
    items: [
      "Diffuse hair loss comparison flowchart.",
      "Patchy alopecia comparison flowchart.",
      "Scarring alopecia educational pathway.",
      "Non-scarring alopecia comparison chart.",
      "Trichoscopy findings reference map.",
      "Diagnostic uncertainty review checklist.",
    ],
    value: 19,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/0823791c-259d-4e81-8d2b-9837dc1d48de.jpg",
  },
  {
    number: 4,
    title: "The 15-Minute Hair Loss Assessment Toolkit™",
    headline: "Put the Five-Stage Framework Into One Practical Worksheet.",
    intro: "This is the companion resource to the main assessment framework.",
    items: [
      "Three-minute history review template.",
      "Three-minute pattern assessment worksheet.",
      "Three-minute trichoscopy findings checklist.",
      "Four-minute differential diagnosis review sheet.",
      "Two-minute documentation template.",
      "Complete initial assessment worksheet.",
    ],
    note: "The suggested time allocations are workflow design targets, not guaranteed clinical completion times.",
    value: 17,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/bc2cabe9-e640-40de-8943-7643b3858344.jpg",
  },
  {
    number: 5,
    title: "The Alopecia Clinical Quick Reference Guide™",
    headline: "Keep Important Clinical Comparisons Organized in One Convenient Resource.",
    intro: "A concise educational reference for reviewing essential concepts from the complete collection.",
    items: [
      "Twelve-condition overview.",
      "Scarring versus non-scarring comparison.",
      "Selected trichoscopy findings summary.",
      "Hair loss pattern reference tables.",
      "Assessment framework reminders.",
      "Differential diagnosis study sheets.",
    ],
    value: 19,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/b4c6f8b1-23bb-4fc0-9e88-8709ae2af276.jpg",
  },
];
